"use client";

import NextLink, { LinkProps } from "next/link";
import { Link as MuiLink, LinkProps as MuiLinkProps } from "@mui/material";

type AppLinkProps = Omit<MuiLinkProps, "href" | "component"> & {
  href: LinkProps["href"];
  prefetch?: LinkProps["prefetch"];
  replace?: LinkProps["replace"];
  scroll?: LinkProps["scroll"];
};

export const AppLink = ({
  href,
  prefetch,
  replace,
  scroll,
  ...props
}: AppLinkProps) => {
  return (
    <MuiLink
      component={NextLink}
      href={href}
      prefetch={prefetch}
      replace={replace}
      scroll={scroll}
      {...props}
    />
  );
};
